var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c("table", { staticClass: "table is-narrow is-fullwidth" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.unidadCompuesta.ejecuciones, function (accion) {
            return _c("tr", { key: accion.id }, [
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("moment")(new Date(accion.updated_at), "DD/MM/YYYY")
                  )
                ),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(accion.documento_evento.nombre))]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(accion.usuario.nombre) +
                    " " +
                    _vm._s(accion.usuario.apellido)
                ),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "has-text-centered" }, [
                accion.finalizada
                  ? _c("span", { staticClass: "tag is-success" }, [
                      _c("i", { staticClass: "fas fa-check" }),
                    ])
                  : _c("span", { staticClass: "tag is-warning" }, [
                      _c("i", { staticClass: "fas fa-clock" }),
                    ]),
              ]),
            ])
          }),
          _vm._v(" "),
          _vm.unidadCompuesta.ejecuciones.length === 0
            ? _c("tr", [_vm._m(1)])
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Fecha")]),
        _vm._v(" "),
        _c("th", [_vm._v("Evento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Responsable")]),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "has-text-centered", attrs: { width: "120" } },
          [_vm._v("Estado")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { staticClass: "section has-text-centered" }, [
        _vm._v("Aún no se han ejecutado eventos"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }